import React from 'react'

import { LntButton } from '@app/components/base'

import { BUTTON_TYPE, SIZE } from '@app/constants'

import styles from './styles.module.scss'

import type { CommonExternalSearchCatalogFooterProps } from './types'

export const CommonExternalSearchCatalogFooter: React.FC<CommonExternalSearchCatalogFooterProps> = ({
  disabled,
  onAddProduct
}) => {
  return (
    <div className={ styles.commonExternalSearchCatalogFooter__button }>
      <LntButton
        type={ BUTTON_TYPE.primary }
        size={ SIZE.middle }
        onClick={ onAddProduct }
        disabled={ disabled }
      >
        Добавить
      </LntButton>
    </div>
  )
}
